<div class="convert-834">
  <h1>Convert 834</h1>

  <div class="editor-header">
    <div class="label">Input</div>
    <div class="mode-actions">
      <button mat-button type="button" [disabled]="!inputIsJson" (click)="switchInputToText()">Text</button>
      <button mat-button type="button" [disabled]="inputIsJson" (click)="switchInputToJson()">JSON</button>
    </div>
  </div>

  @if (inputIsJson) {
    <div class="json-editor-wrap">
      <json-editor [options]="inputEditorOptions" [data]="inputJson || {}" (change)="onInputJsonChanged($event)"></json-editor>
    </div>
  } @else {
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Paste 834 or JSON</mat-label>
      <textarea
        matInput
        rows="16"
        [ngModel]="inputPayload"
        (ngModelChange)="onInputTextChanged($event)"
        placeholder="Paste EDI 834 text or JSON here"
      ></textarea>
    </mat-form-field>
  }

  <div class="actions">
    <button mat-raised-button color="primary" [disabled]="isLoading" (click)="convertToJson()">
      Convert 834 -> JSON
    </button>
    <button mat-raised-button color="accent" [disabled]="isLoading" (click)="convertTo834()">
      Convert JSON -> 834
    </button>
  </div>

  @if (isLoading) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }

  @if (errorMessage) {
    <div class="error">{{ errorMessage }}</div>
  }

  <div class="editor-header">
    <div class="label">Response</div>
  </div>
  @if (responseIsJson) {
    <div class="json-editor-wrap">
      <json-editor [options]="outputEditorOptions" [data]="responseJson || {}"></json-editor>
    </div>
  } @else {
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Response</mat-label>
      <textarea matInput rows="16" [value]="responsePayload" readonly></textarea>
    </mat-form-field>
  }
</div>
